module.exports = {"StatusCode":200,"Payload":[{"detailsSubmitted":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getStripeConnectAccount.json
// module id = +xbZ
// module chunks = 0